import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { InvoicesRoutes } from '@utils/routes.utils';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';

const InvoicesScreen = () => {
  const {t} = useTranslation();

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize="30px" fontWeight="700">
          {t('invoices.title')}
        </Typography>
      </Stack>
      <Stack flex={1}>
        <RoutesTabsComponent routes={InvoicesRoutes.routes()}/>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default InvoicesScreen;
